import React from 'react';
import { useTranslation } from 'react-i18next';

import {
    useHotelTransferAtom,
    usePrivateTransferAtom,
    useRailAndFlyAtom,
} from 'hooks/form/filter';
import { useChangedFilterList } from 'hooks/form/useChangedFilterList';
import { QaIdentifier } from 'hooks/useQa';

import { filterPredicateIsTruthy } from 'utility/Check/filterPredicateIsTruthy';

import { SearchParam } from 'types/Search/params';

import Segment from '../Segment';

import { getSelected } from './__helper/getSelected';
import HotelTransfer from './__partials/HotelTransfer';
import PrivateTransfer from './__partials/PrivateTransfer';
import RailAndFly from './__partials/RailAndFly';

interface TransferProps {
    hasPrivateTransfer?: boolean;
}

const Transfer = ({ hasPrivateTransfer = false }: TransferProps) => {
    const { t } = useTranslation();
    const [hotelTransfer, setHotelTransfer] = useHotelTransferAtom();
    const [privateHotelTransfer, setPrivateTransfer] = usePrivateTransferAtom();
    const [railAndFly, setRailAndFly] = useRailAndFlyAtom();

    const { onClear } = useChangedFilterList();
    const filterList = [
        HotelTransfer(),
        hasPrivateTransfer ? PrivateTransfer() : null,
        RailAndFly(),
    ].filter(filterPredicateIsTruthy);

    const headline = t('TRANS-transfer');

    return (
        <Segment
            headline={{ text: headline }}
            withDeleteLink
            qaIdentifier={QaIdentifier.Search_Filter_Section_Transfer}
            onDelete={() => {
                onClear(() =>
                    getSelected(hotelTransfer, railAndFly, privateHotelTransfer)
                );
                setHotelTransfer(false);
                setPrivateTransfer(false);
                setRailAndFly(false);
            }}
            filterList={filterList}
            kiFilterGroupData={{
                refKey: SearchParam.HotelTransfer,
                label: headline,
                multi: true,
            }}
        />
    );
};

export default Transfer;
